import { logE } from "@blacknut/logging/dist";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  dismissPageError,
  fetchPageGenre,
  paginatePagegameGenre,
} from "../../redux/actions/Page";
import { State } from "../../redux/reducers";
const TAG = "GameByGenre";

export const usePageGameGenre = (props: {
  tilesLimit: number;
  limit: number;
  id: string;
}) => {
  const { tilesLimit, limit, id } = props;
  const dispatch = useDispatch();
  const { loading, page, error, paginating } = useSelector(
    (state: State) => state.pagesState.pages[id],
  ) || {
    loading: false,
    paginating: false,
  };

  const mounted = React.useRef(false);
  React.useEffect(() => {
    if (!page && !mounted.current) {
      mounted.current = true;
      const init = async () => {
        try {
          await fetchPageGenre(id, limit, tilesLimit)(dispatch);
        } catch (e) {
          logE(TAG, "Caught error getting page %o %o", id, e);
        }
      };
      init();
    }
  }, [page, loading, error, id, limit, tilesLimit, dispatch]);

  return {
    loading,
    page,
    loadingError: error,
    paginating: paginating,
    dismissLoadingError: React.useCallback(() => {
      dismissPageError(id)(dispatch);
    }, [dispatch, id]),
    paginate: React.useCallback(async () => {
      if (page) {
        if (page.total > page.lists.length && !paginating) {
          try {
            await paginatePagegameGenre(id, page, limit, tilesLimit)(dispatch);
          } catch (e) {
            logE(TAG, "Caught eror on page pagination %o: %o", page.uuid, e);
          }
        }
      }
    }, [, dispatch, id, limit, page, paginating, tilesLimit]),
  };
};
